import cn from 'classnames';
import type { ProductComponentAbstractProps } from 'containers/payments/ProductsListAbstract';
import React, { useCallback } from 'react';

import { Border, BorderTypeEnum } from 'components/domains/common/Border';

import { DiscountLabel } from '../DiscountLabel';
import type { CurrencyEnum } from '../FormattedPrice';
import { ProductMiniTitle } from '../ProductMiniTitle';

import styles from './styles.module.scss';

export interface ProductMiniProps extends ProductComponentAbstractProps {
  className?: string;
}

export const ProductMini: React.FC<ProductMiniProps> = ({
  className,
  product,
  isSelected,
  onClick,
}) => {
  const status = isSelected
    ? BorderTypeEnum.SELECTED
    : BorderTypeEnum.NOT_ACTIVE;
  const {
    interval,
    discount_price: discountPrice,
    discount,
    price,
    currency,
    
  } = product.prices[0];
  const { is_current: isCurrent, } = product;
  const onClickHandler = useCallback(() => {
    if (isCurrent) {
      return;
    }

    onClick(product);
  }, [isCurrent, product, onClick]);

  return (
    <Border
      type={status}
      className={styles.border}
      classNameSelected={styles.borderSelected}
      onClick={onClickHandler}
    >
      <div
        className={cn(styles.container, className, {
          [styles.currentPlan]: status === BorderTypeEnum.SELECTED,
        })}
      >
        <ProductMiniTitle
          currency={currency as CurrencyEnum}
          discount={discount}
          price={price}
          discountPrice={discountPrice}
          interval={interval}
          isCurrent={isCurrent}
        />
        {!isCurrent && discount ? (
          <DiscountLabel inline discount={discount} />
        ) : null}
      </div>
    </Border>
  );
};

ProductMini.displayName = 'Payments/ProductMini';
